


































import Vue from "vue";

import moment from "moment";

import { GetTenderSituationResponse } from "@/api/dto/Tender";
import { getTenderSituation } from "@/api/Tender";

/** 入札状況 */
type Situation = Pick<
  GetTenderSituationResponse,
  "tenderUserId" | "tenderAt" | "amount" | "questionLimit"
>;

type Data = {
  /** 入札状況 */
  situation: Situation[];
};

/**
 * 入札状況モーダル
 */
export default Vue.extend({
  name: "TenderSituationModal",
  props: {
    /** 入札状況 */
    dealId: String,
  },
  data(): Data {
    return {
      situation: [],
    };
  },
  async created() {
    try {
      // 入札状況取得
      const response = await getTenderSituation(this.dealId);
      this.situation = response.map((situation) => ({
        tenderUserId: situation.tenderUserId,
        tenderAt: situation.tenderAt,
        amount: situation.amount,
        questionLimit: situation.questionLimit,
      }));
    } catch (e) {
      this.$emit(
        "errorToast",
        "入札状況取得ができませんでした。しばらく経ってからやり直してください。"
      );
    }
  },
  methods: {
    formatDate(date: Date) {
      return moment(date).format("YYYY年MM月DD日 HH:MM");
    },
    getQuestionLimitLabel(questionLimit: number | null) {
      if (!questionLimit) {
        return "無制限";
      } else {
        return `${questionLimit}回`;
      }
    },
    // モーダルを閉じる
    close() {
      this.$emit("close");
    },
  },
});
